import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { TocRegionTileFragment } from "../../client/generated";
import { assertTypeName } from "../../client/guards";
import { RegionTile } from "../../regions/RegionTile";

type Props = {
  fragment: TocRegionTileFragment;
  tocAttributeId: string;
  children: React.ReactNode;
  dispatch: Dispatch<EditorAction>;
};

export function TOCRegionTile({
  fragment,
  tocAttributeId,
  children,
  dispatch,
}: Props) {
  const tocAttribute = fragment.attributes.find((a) => a.id === tocAttributeId);
  assertTypeName(tocAttribute?.__typename === "TableOfContentsAttribute");

  const onClick = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "update",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTile fragment={fragment} preview="" onClick={onClick}>
      {children}
    </RegionTile>
  );
}
